import React from 'react';

import { useField } from 'formik';
import { Form } from 'react-bootstrap';

interface ISimpleSwitchProps {
  [key: string]: any;
  name: string;
  label: string;
  disabled?: boolean;
  dataTestId?: string;
  description?: string;
}

const SimpleSwitchField = ({
  label,
  name,
  disabled = false,
  dataTestId,
  description
}: ISimpleSwitchProps) => {
  const [field, meta, helpers] = useField(name);
  const invalid = meta.touched && meta.error ? true : false;
  const { setValue, setTouched } = helpers;

  const handleClick = (value: boolean) => {
    setValue(value);
    setTouched(true, false);
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between mb-3"
        data-test={`${dataTestId}-container`}
      >
        <Form.Label className="m-0">{label}</Form.Label>
        {description && (
          <Form.Text className="mx-4 text-justify flex-grow-1">{description}</Form.Text>
        )}
        <Form.Check
          data-test={dataTestId}
          data-test-value={field.value}
          type="switch"
          id={name}
          checked={field.value}
          disabled={disabled}
          onChange={() => handleClick(!field.value)}
        />
      </div>
      {invalid && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default SimpleSwitchField;
